import React, { useEffect, useState } from 'react';
import styles from './EventCard.module.scss';
import moment from 'moment';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../Custom/DeletePopup';
import EventInfoModal from './EventInfoModal';
import { useDeleteEvent } from '../../../Hooks/Events';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import ActivityStatus from '../../Atoms/Inputs/ActivityStatus';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import calendarBlack from '../../../assets/Imagess/calendar-black.svg';
import clockBlack from '../../../assets/Imagess/clock-black.svg';
import locationIcon from '../../../assets/Imagess/location-pin-black.svg';
import { isEmpty } from 'lodash';
import { useToast } from '../Custom/CustomToaster/Toast';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function EventCard({ event, refetchEvents }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const customizedToast = useToast();
  const {
    mutate: deleteEvent,
    isLoading: isDeletingEvent,
    isSuccess,
  } = useDeleteEvent(event?.eventId);

  useEffect(() => {
    setIsActive(event?.isActive);
  }, [event]);

  useEffect(() => {
    if (isSuccess) {
      customizedToast.open('تم الحذف بنجاح');
      setShowDeletePopup(false);
      refetchEvents();
    }
  }, [isSuccess]);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        navigate(`/home/edit-event/${event?.eventId}`);
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  const activateEvent = useMutation({
    mutationFn: () => {
      return axios.post(
        API_URL + `/api/News/ActivateEvents/${event?.eventId}/${!isActive}`,
        {},
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: (data) => {
      customizedToast.open('Status is changed successfully');
      setIsActive(!isActive);
      refetchEvents();
    },
    onError: (error) => {
      alert(error?.message);
    },
  });

  return (
    <div className={styles['news-card']}>
      <div
        className={styles['image-container']}
        onClick={() => setShowInfo(true)}
      >
        <img
          src={sanitizeAndValidateUrl(`${event?.url}${event?.image1}`)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
          className={styles['event-card-image']}
        />
        <img
          src={sanitizeAndValidateUrl(`${event?.url}${event?.image2}`)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
          className={styles['event-card-image']}
        />
      </div>
      <div className={styles['news-card-info']}>
        <div className={styles['row']}>
          <div className={styles['description']}>
            <p className={styles['title']} style={{ fontSize: '14px' }}>
              {event?.title_AR}
            </p>
          </div>
          <div>
            <InfoButton
              icon={moreInfo}
              className={styles['more-info']}
              data={menuItems}
              left
            />
          </div>
        </div>
      </div>
      <div
        className={styles['time-icon-row']}
        style={{ paddingRight: '14px', paddingLeft: '14px' }}
      >
        <div className={styles['time-icon-container']}>
          <p>{moment(event?.eventDate).format('YYYY/MM/DD')}</p>
          <img src={calendarBlack} />
        </div>
        <div className={styles['time-icon-container']}>
          <p>{moment(event?.eventDate).format('h:mm A')}</p>
          <img src={clockBlack} />
        </div>
      </div>
      <div
        className={styles['time-icon-row']}
        style={{ paddingRight: '14px', paddingLeft: '14px', marginTop: '14px' }}
      >
        <div className={styles['time-icon-container']}>
          <p>{!isEmpty(event?.locationLink) ? event?.locationLink : '-'}</p>
          <img src={locationIcon} />
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title="حدث"
          handleDelete={() => {
            deleteEvent();
            refetchEvents();
          }}
          isLoading={isDeletingEvent}
        />
      )}
      {showInfo && (
        <EventInfoModal
          event={event}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
        />
      )}
      <ActivityStatus isActive={isActive} activate={activateEvent} />
    </div>
  );
}

export default EventCard;
